function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M15.8225379,28.5 L15.8225379,20.0019531 L13.0625,20.0019531 L13.0625,16.625 L15.8225379,16.625 L15.8225379,13.9642578 C15.8225379,11.0734375 17.5354167,9.5 20.0363636,9.5 C21.2346591,9.5 22.2638258,9.59277344 22.5625,9.63359375 L22.5625,12.6542969 L20.8280303,12.6542969 C19.467803,12.6542969 19.2051136,13.3222656 19.2051136,14.2982422 L19.2051136,16.625 L22.2746212,16.625 L21.8535985,20.0019531 L19.2051136,20.0019531 L19.2051136,28.5",
  id: "path-facebook"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "LANDING-DONACI\xD3N-SANGRE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Landing-donacion-sangre",
  transform: "translate(-408.000000, -3062.000000)"
}, React.createElement("g", {
  id: "w3share",
  transform: "translate(105.000000, 2705.000000)"
}, React.createElement("g", {
  id: "facebook_icon",
  transform: "translate(303.000000, 357.000000)"
}, React.createElement("circle", {
  id: "circle",
  stroke: "#FFFFFF",
  cx: 19,
  cy: 19,
  r: 18.5
}), React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-facebok"
})), React.createElement("use", {
  id: "facebook_form",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  xlinkHref: "#path-facebook"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 38 38"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/facebook.75fb8e04.svg";
export { SvgComponent as ReactComponent };